export const ARCHIVED_ORGANIZATIONS_LIST_HREF =
  '/admin/membership/archived-users?contactType=organization';

export const isArchivedOrganizationAdminPath = (pathname: string): boolean =>
  pathname.includes('/admin/membership/archived-users/organizations/');

export const getOrganizationAdminBasePath = (options: {
  organizationId: string;
  archivedOnly?: boolean;
}): string => {
  if (options.archivedOnly) {
    return `/admin/membership/archived-users/organizations/${options.organizationId}`;
  }

  return `/admin/companies/${options.organizationId}`;
};
